module.exports = __webpack_public_path__ + "img/nvocc.04c137af.jpg";